import axiosClient from "./axiosClient";

export async function getHomeFeed(take = 10) {
  const response = await axiosClient.get("/Recommendations/home", { params: { take } });
  return response.data;
}

export async function getRecommendationsFeed({ skip = 0, take = 10, seed = 1 } = {}) {
  const response = await axiosClient.get("/Recommendations/feed", { params: { skip, take, seed } });
  return response.data;
}
